import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { QButton, QIcon, QText, useCurrentUser } from '@qualio/ui-components';

import { EditorMode } from '../../../../../util/EditModeUtils';
import { ButtonGroupContext } from '../../../Contexts/ButtonGroupContext';
import {
  DocumentOverviewContext,
  EditorStatus,
  EditorStatusContext,
} from '../../Context';
import { shouldRenderEditButton } from '../../RenderLogic';

type EditButtonProps = {
  setEditorMode: (value: EditorMode) => void;
};

export const EditButton = ({ setEditorMode }: EditButtonProps) => {
  const { t } = useTranslation();
  const currentUser = useCurrentUser();
  const { qualioDocument, currentEditorMode } = useContext(
    DocumentOverviewContext,
  );
  const { isDisabled } = useContext(ButtonGroupContext);
  const { docEditorStatus, ccEditorStatus } = useContext(EditorStatusContext);

  if (!shouldRenderEditButton(qualioDocument, currentUser, currentEditorMode)) {
    return null;
  }

  const isConnectingToEditingSession =
    docEditorStatus === EditorStatus.CONNECTING ||
    ccEditorStatus === EditorStatus.CONNECTING;

  return (
    <QButton
      isDisabled={isDisabled || isConnectingToEditingSession}
      onClick={() => setEditorMode(EditorMode.EDIT)}
      aria-label="edit-button"
      variant="outline"
      data-cy="document-edit-button"
    >
      {' '}
      <QIcon iconName={'Edit3'} /> <QText pl={1}>{t('buttons.edit')}</QText>
    </QButton>
  );
};
